import CognitoUserList from './abstract/CognitoUserList'
import Config from '../../../Config'

class AdminUserList extends CognitoUserList {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, adminUserList: ''}
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '事務局管理者'
    this.userRoleUrl = 'admin_user'
    this.userRole = 'admin'
  }
}

export default AdminUserList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/AdminUserList.js